import React, {Component} from 'react'
import {Card, CardTitle, Container, Badge, Col, Row} from 'reactstrap'

class Route extends Component {
  render() {
    const {people, event, signup } = this.props;
    var myRide = []

    function compare( a, b ) {
      if ( a.stop < b.stop ){
        return -1;
      }
      if ( a.stop > b.stop ){
        return 1;
      }
      return 0;
    }
    
    for (var person of people) {
      if (person.route === signup.route) {
        myRide.push(person)
      }
    }
    myRide.sort( compare );
    myRide.shift();

    return (
      <div>
          {signup.role === 'Driver' ? (
          <div>
            
            <Card inverse color="dark">
            <Container>
            <br></br>
            <Row>
              <Col><h3>Drive Information <Badge style={{backgroundColor: `${signup.color}`}}> </Badge> </h3></Col>
            </Row>
            {myRide.map(rider => (<div>
              <h5>Pickup {rider.firstName} {rider.lastName}.</h5>
              <h7>{rider.location}</h7><br/><br/>
            </div>))}
            <h5>Continue to {event.location}.</h5>
            <br></br>
            </Container>   
            </Card>
          </div>) : (
          <div>
            <Card inverse color="dark">
            <Container>
              <br></br>
              <CardTitle>
                <Row>
                  <Col><h3>Ride Information <Badge style={{backgroundColor: `${signup.color}`}}> </Badge> </h3></Col>
                </Row>
              </CardTitle>
              <h5><b>Driver: </b>{signup.driver}</h5>
              <h5><b>Location:</b> {signup.location}</h5>
              <h5><b>Pickup Order: </b>{signup.stop}</h5>
              <br></br>
            </Container>
            </Card>     
          </div>
          )}
      </div>
    )
  }
}  

export default Route;